export default function (categories: Category[]) {
  return categories.some(category => category.items.filter(item => item.alcoholic).length > 0);
}
